import { SvgIcon } from '@material-ui/core';

export const IconBusiness = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M5.414 2H0v20h24V3h-9v7H9V5.586L5.414 2zM15 12v8H9v-8h6zm2 8V5h5v15h-5zM7 20H2V4h2.586L7 6.414V20z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
